import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const airspace: Palette[] = [
    {
        name: 'FCA/FEAs',
        id: GDFPalletCode.fca,
        type: 'categorical',
        entries: [
            {
                label: 'AFP (solid)',
                color: 'rgb(255,0,0)'
            },
            {
                label: 'FSM eligible (FCA/solid or FEA/dashed)',
                color: 'rgb(255,135,0)'
            },
            {
                label: 'FCA (solid)',
                color: 'rgb(255,255,0)'
            },
            {
                label: 'FEA (dashed)',
                color: 'rgb(146,254,137)'
            }
        ]
    },
    {
        name: 'AFP delays',
        id: GDFPalletCode.afp,
        type: 'categorical',
        entries: [
            {
                label: 'AFP (solid)',
                color: 'rgb(255,0,0)'
            },
            {
                label: 'FSM eligible (FCA/solid or FEA/dashed)',
                color: 'rgb(255,135,0)'
            },
            {
                label: 'FCA (solid)',
                color: 'rgb(255,255,0)'
            },
            {
                label: 'FEA (dashed)',
                color: 'rgb(146,254,137)'
            }
        ]
    },
    {
        name: 'Dynamic SUA',
        id: GDFPalletCode.dsua,
        type: 'categorical',
        withValues: true,
        entries: [
            { label: '12-24 hours', color: 'rgb(255,0,255)', value: 1 },
            { label: '8-12 hours', color: 'rgb(203,102,204)', value: 2 },
            { label: '4-8 hours', color: 'rgb(123,255,255)', value: 3 },
            { label: '2-4 hours', color: 'rgb(136,203,102)', value: 4 },
            { label: '1-2 hours', color: 'rgb(255,255,102)', value: 5 },
            { label: '< 1 hour', color: 'rgb(255,204,102)', value: 6 },
            { label: 'Active', color: 'rgb(204,51,0)', value: 7 },
            { label: 'Not scheduled', color: 'rgb(189,181,206)', value: 0 }
        ]
    }
];
